//REORGANIZE_THIS_FILE? -- needs to be completely overhauled

function translate(englishString) {
   // console.log(englishString)
   // try {
   //    JSON.parse(window.localStorage.getItem('emp_content'));
   // } catch (err) {
   return englishString;

   //}

   //NOTHING BELOW THIS LINE EVER HAPPENS -- WE NEED TO OVERHAUL TRANSLATE
   //LEAVING IT HERE FOR POSTERITY
   //Going to comment everything below for ESLint error no-unreachable -Alex

   // if (typeof englishString !== "string") {
   //    englishString = englishString.toString();
   //    // if (process.env.BUILD === 'development')
   //    //    console.error(
   //    //       `translate() received a non-string prop: ${englishString}`
   //    //    );
   // }

   // const content = JSON.parse(window.localStorage.getItem("emp_content")) || [];

   // const language = window.localStorage.getItem("emp_language") || "en";

   // let translation = content.find(
   //    (str) =>
   //       str.en.trim().toLowerCase() == englishString.trim().toLowerCase(),
   // );

   // if (!translation) {
   //    // if (process.env.BUILD === 'development')
   //    //    console.error(`Translation error: ${englishString} wasn't found`);
   //    return englishString;
   // }

   // return translation[language];
}

export { translate };
